









































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import ModulesHelper from '@core/services/modules.helper';
import { OrderItem } from '@accounting/interfaces/order-item';

@Component({
  name: 'bpc-summary-lines',
  components: {},
})
export default class InvoiceSummaryLines extends Vue {
  @Prop(Array) readonly lines: OrderItem[];
  @Prop(String) readonly baseKey: string;
  @Prop(Boolean) readonly withTotal: boolean;
  @Prop(Number) readonly totalAmount: number;
  @Prop(Number) readonly totalTax: number;

  get withDiscounts(): boolean {
    return !!this.lines?.find(item => item.discount) || false;
  }

  truncateString(str, num): string {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (!str) {
      return str;
    }
    if (str.length <= num) {
      return str;
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + '...';
  }

  formatDate(date) {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
  }
  formatTime(time): string {
    if (time) {
      return time.substr(0, 5);
    }
    return '';
  }
  formatPrice(value: string | number) {
    if (!value) {
      value = '0';
    }
    if (typeof value === 'string') {
      value = value.replace(',', '');
    }

    // Number of decimals
    value = value + '';
    let decimalsLength = 0;
    const splitValue = value.split('.');
    if (splitValue[1]) {
      decimalsLength = splitValue[1].length;
    }

    return (
      parseFloat(String(value))
        .toFixed(Math.max(2, decimalsLength))
        .replace('.', ',') + ' €'
    );
  }
  formatAmount(value: string | number): string {
    if (!value) {
      value = '0';
    }
    if (typeof value === 'string') {
      value = value.replace(',', '');
    }
    return (
      parseFloat(String(value))
        .toFixed(2)
        .replace('.', ',') + ' €'
    );
  }

  isTaxManagementModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.TAX_MANAGEMENT_MODULE_NAME);
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
